<div class="__request-support-button">
	<div class="__request-support-button__text text-muted">
		<mat-icon class="mr1 text-muted">help</mat-icon>
		¿Problemas para acceder?
	</div>
	<a
		href="{{supportLink}}"
		target="_blank"
		rel="noopener noreferrer"
		class="__link"
	>
		Solicite soporte
	</a>
</div>
